import React from "react";
import { useFormikContext, getIn } from "formik";
import { LabelField } from "components/LabelField";
import { fontConfig } from "theme/fontConfig";

const CheckboxField = ({
  name,
  title,
  topLabel = "",
  showTopLabel = false,
  titleStyles = {
    fontSize: 14,
    fontFamily: fontConfig.FormManageCheckboxFieldTitleStylesFont.family,
    fontWeight: 500,
    color: "#3F4254",
  },
  style,
  className = "",
  handleAction,
  ...props
}) => {
  const { values, setFieldValue } = useFormikContext();
  const checked = getIn(values, name) || false;

  const handleChange = (e) => {
    handleAction && handleAction(e);
    setFieldValue(name, e.target.checked);
  };

  return (
    <div
      className={`d-flex flex-column ${className}`}
      style={{
        backgroundColor: "transparent",
        ...style,
      }}
    >
      <div style={{ minHeight: showTopLabel ? 40 : 0 }}>
        {showTopLabel && (
          <LabelField title={topLabel} style={{ marginBottom: 4 }} />
        )}
      </div>

      <div
        className="d-flex"
        style={{
          alignItems: "baseline",
        }}
      >
        <label
          className="checkbox checkbox-lg checkbox-single mr-4"
          style={{
            cursor: props?.disabled ? "not-allowed" : "pointer",
            opacity: props?.disabled ? 0.1 : 1,
          }}
        >
          <input
            type="checkbox"
            name={name}
            checked={checked}
            onChange={handleChange}
            {...props}
          />
          <span />
        </label>

        <LabelField
          title={title}
          style={{ ...titleStyles, opacity: props?.disabled ? 0.5 : 1 } || {}}
        />
      </div>
    </div>
  );
};

export default CheckboxField;
